<template>
  <div class="wrap_box">
    <no-login class="no-color" :regis="true"></no-login>
    <div class="regis_wrap">
      <div class="regis">
        <div class="left">
          <el-steps :active="stepActive" direction="vertical" class="h40">
            <el-step :title="selectedLevel==1?$t('registerEmail_21004'):$t('registerEmail_00002')" :description="selectedLevel==1?$t('registerEmail_21005'):$t('registerEmail_00007')"></el-step>
            <el-step :title="selectedLevel==1?$t('registerEmail_00004'):$t('registerEmail_00004')" :description="selectedLevel==1?$t('registerEmail_20058'):$t('registerEmail_20058')"></el-step>
            <el-step v-if="selectedLevel==1" :title="$t('registerEmail_00023')" :description="$t('registerEmail_20060')"></el-step>
          </el-steps>
        </div>
        <div class="right">
          <div class="wrap" v-if="selectedLevel==1">
            <!-- 验证注册码 -->
            <div class="step_two" v-show="stepActive==0">
              <CodeForm @next="next" />
            </div>
            <!-- 填写注册信息 -->
            <div class="step_two" v-show="stepActive==1">
              <RegisInfo :regCode="regCode" :product="product" :selectedLevel="selectedLevel" @next="next" />
            </div>
            <!-- 绑定微信公众号 -->
            <div class="step_one" v-show="stepActive==2">
              <WechatPublic @next="next" />
            </div>
          </div>
          <div class="wrap" v-if="selectedLevel==2">
            <!-- 搜索运营商 -->
            <div class="step_one" v-show="stepActive==0">
              <SearchInfo @next="next" :product="product" />
            </div>
            <!-- 填写注册信息 -->
            <div class="step_two" v-show="stepActive==1">
              <RegisInfo :codeInfo="codeInfo" :product="product" :selectedLevel="selectedLevel" @next="next" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  requestUrl,
  ajax,
  checkLogin,
  getQueryString,
} from "@/assets/utils/network";
import SearchInfo from "../registerInternational/common/search.vue";
import PhoneInfo from "./common/phone.vue";
import RegisInfo from "../registerInternational/common/regisInfo.vue";
import noLogin from "../login/common/head_no_login.vue";
import WechatPublic from "./common/weChat.vue";
import CodeForm from "./common/code.vue";
export default {
  components: {
    SearchInfo,
    PhoneInfo,
    RegisInfo,
    noLogin,
    WechatPublic,
    CodeForm,
  },
  data() {
    return {
      product: "",
      stepActive: 0, // 步骤条 -- 激活第几个
      codeInfo: {},
      ruleForm: {}, // 注册参数
      regCode: "", // 注册码
    };
  },
  created() {
    window.document.title = this.$t("registerEmail_00001");
    this.product = window.product_area;
    this.selectedLevel = getQueryString("selectedLevel");
    var stepActive = getQueryString("stepActive");
    if (stepActive) {
      this.stepActive = Number(stepActive);
    }
    if (getQueryString("alert")) {
      this.stepActive = 2;
    }
  },
  methods: {
    next(val) {
      console.log(val)
      let { tag, stepActive } = val;
      this.stepActive = Number(stepActive);
      if (tag == "search") {
        this.codeInfo = val.codeInfo;
      } else if (tag == "code") {
        this.regCode = val.codeInfo.regCode;
      } else if (tag == "regisInfo") {
        this.ruleForm = val.codeInfo;
        this.register();
      }
    },
    // 注册
    register() {
      var dealer = new Object();
      dealer.title = this.ruleForm.title;
      dealer.loginId = this.ruleForm.loginId;
      dealer.password = this.ruleForm.password;
      dealer.contactName = this.ruleForm.contactName;
      dealer.contactMobile = this.ruleForm.contactMobile;
      dealer.smsAuthCode = this.ruleForm.smsAuthCode;
      dealer.selectedLevel = this.selectedLevel;
      dealer.currencyType = this.ruleForm.currency;
      dealer.dealerLicenseCode = this.regCode;
      dealer.skipWechatOa = this.ruleForm.skipWechatOa;
      var om = this;
      ajax({
        type: "POST",
        url: requestUrl + "/dealer/registration",
        data: JSON.stringify(dealer),
        dataType: "json",
        success: function (response) {
          var info = JSON.parse(response);
          if (info.error != null) {
            if (
              info.error.code == "DUP_LOGINID" ||
              info.error.code == "DUP_TITLE"
            ) {
              clearInterval(om.interval);
            }
            // 注册码错误
            if (info.error.code == "BAD_LICENSE_CODE") {
              om.$message.error(om.$t("registerEmail_21002"));
              return false;
            }
            om.$message.error(
              info.error.msg == null ? info.error.code : info.error.msg
            );
            return false;
          }
          if (info.result != null) {
            if (om.selectedLevel == 2 || om.ruleForm.skipWechatOa) {
              var result = info.result;
              om.registerDealer(result.id);
            } else {
              om.stepActive = 2;
            }
          }
        },
        fail: function (response) {
          om.$message.error("服务器响应超时");
        },
      });
    },
    registerDealer(id) {
      var info = new Object();
      info.id = id;
      info.inviteCode = this.codeInfo.codeId;
      var om = this;
      ajax({
        type: "POST",
        url: requestUrl + "/dealer",
        data: JSON.stringify(info),
        dataType: "json",
        success: function (response) {
          if (info.error != null) {
            if (info.error.code == "NOT_LOGIN") {
              window.location.href = "./login.html?l=0";
            }
            om.$message.error(
              info.error.msg == null ? info.error.code : info.error.msg
            );
          } else {
            window.location.href = "./preview.html";
            om.$message({
              message: "设置成功",
              type: "success",
            });
          }
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/css/reset.css";
@import "../registerInternational/style.scss";
.no-color {
  #privacy {
    color: #212943 !important;
  }
}
</style>